<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{$t("message.account.change.title")}}</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" :replaceList="errMessageReplaceList" message-key="message.account.change.error." />
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="12" class="text-right">
        <span class="red--text">※</span>{{$t("message.account.change.desc.text1")}}
      </v-col>
    </v-row>

    <!-- ID -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.account.change.label.id")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.mailAddress"
          v-bind:placeholder="$t('message.account.change.ph.id')"
          id="id"
          hide-details
          solo
          dense
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- パスワード -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.account.change.label.password")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <!-- password自動入力抑止 -->
        <v-text-field
          type="password"
          class="dummyPasswordFld"
        ></v-text-field>
        <v-text-field
          :append-icon="view.show ? 'mdi-eye' : 'mdi-eye-off'"
          :type="view.show ? 'text' : 'password'"
          @click:append="view.show = !view.show"
          autocomplete="off"
          v-model="form.password"
          v-bind:placeholder="$t('message.account.change.ph.password')"
          id="password"
          hide-details
          solo
          dense
          maxlength="100"
        ></v-text-field>
        <v-text-field
          :append-icon="view.showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
          :type="view.showConfirm ? 'text' : 'password'"
          @click:append="view.showConfirm = !view.showConfirm"
          autocomplete="off"
          v-model="form.passwordConfirm"
          v-bind:placeholder="$t('message.account.change.ph.passwordConfirm')"
          id="passwordConfirm"
          hide-details
          solo
          dense
          maxlength="100"
          class="mt-2"
        ></v-text-field>
        <div class="mt-2">
        <p />
        <p>{{$t("message.account.change.desc.passwordText1")}}</p>
        <p>{{$t("message.account.change.desc.passwordText2")}}</p>
        </div>

      </v-col>
    </v-row>

    <!-- 氏名 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.account.change.label.name")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.name"
          v-bind:placeholder="$t('message.account.change.ph.name')"
          id="name"
          hide-details
          solo
          dense
          maxlength="50"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 所属 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.account.change.label.group")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ form.groupLargeName[$i18n.locale] }}<span class="mx-2">＞</span>{{ form.groupSmallName[$i18n.locale] }}</mp-input-box>
      </v-col>
    </v-row>

    <!-- 会社 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{ view.companyLabel[$i18n.locale] }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ form.companyName }}</mp-input-box>
      </v-col>
    </v-row>

    <!-- 支社・支局または媒体 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{ view.branchLabel[$i18n.locale] }}<span class="red--text" v-if="form.companyInsNoFlg !== '1' && view.branchList.length > 1">※</span></mp-label>
      </v-col>
      <v-col cols="8">
          <v-select
            v-model="form.branchId"
            :items="view.branchList"
            :label="$t('message.account.change.ph.branch').replace('##BRANCH_LABEL##', view.branchLabel[$i18n.locale])"
            item-text="branchName"
            item-value="branchId"
            :disabled="view.branchList.length == 0 || form.companyInsNoFlg === '1'"
            id="branchId"
            hide-details
            solo
            dense
            @change="changeBranch"
          ></v-select>
          <v-text-field
            v-if="form.branchId != null && form.branchId === constantValue.otherBranchId"
            v-model="form.branchName"
            v-bind:placeholder="$t('message.account.change.ph.branchName').replace('##BRANCH_LABEL##', view.branchLabel[$i18n.locale])"
            id="branchName"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
          <v-text-field
            v-if="$i18n.locale === 'ja' && form.branchId != null && form.branchId === constantValue.otherBranchId"
            v-model="form.branchNameKana"
            v-bind:placeholder="$t('message.account.change.ph.branchNameKana').replace('##BRANCH_LABEL##', view.branchLabel[$i18n.locale])"
            id="branchNameKana"
            hide-details
            solo
            dense
            class="mt-2"
            maxlength="100"
          ></v-text-field>
        </v-col>
    </v-row>

    <!-- 郵便番号 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.account.change.label.postNo")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.postNo"
          hide-details
          v-bind:placeholder="$t('message.account.change.ph.postNo')"
          id="postNo"
          solo
          dense
          maxlength="20"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 都道府県 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.account.change.label.prefCd")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
          <v-select
            v-model="form.prefCd"
            :items="$store.getters.prefCodeList"
            :item-text="getPrefName"
            item-value="kbnCd"
            :label="$t('message.account.change.ph.prefCd')"
            id="prefCd"
            hide-details
            dense
            solo
            maxlength="100"
          ></v-select>
      </v-col>
    </v-row>

    <!-- 市区町村 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.account.change.label.addr1")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.addr1"
          v-bind:placeholder="$t('message.account.change.ph.addr1')"
          id="addr1"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 番地 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.account.change.label.addr2")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.addr2"
          v-bind:placeholder="$t('message.account.change.ph.addr2')"
          id="addr2"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- ビル名 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.account.change.label.addr3")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.addr3"
          v-bind:placeholder="$t('message.account.change.ph.addr3')"
          id="addr3"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 部署 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.account.change.label.busho")}}<span class="red--text" v-if="form.companyInsNoFlg !== '1'">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.busho"
          v-bind:placeholder="$t('message.account.change.ph.busho')"
          id="busho"
          hide-details
          dense
          solo
          maxlength="100"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 電話番号 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.account.change.label.telNo")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.telNo"
          v-bind:placeholder="$t('message.account.change.ph.telNo')"
          id="telNo"
          hide-details
          dense
          solo
          maxlength="20"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 備考 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.account.change.label.remarks")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-textarea
          v-model="form.remarks"
          v-bind:placeholder="$t('message.account.change.ph.remarks')"
          id="remarks"
          hide-details
          dense
          solo
          maxlength="20000"
        ></v-textarea>
      </v-col>
    </v-row>

    <!-- 利用希望サービス -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>
          {{$t("message.account.change.label.services")}}<span class="red--text">※</span>
        </mp-label>
      </v-col>
      <v-col cols="8">
        <v-checkbox v-for="(item) in view.serviceList"
          :key="item.serviceId"
          v-model="form.services"
          :value="item.serviceId"
          :disabled="!(item.groupLargeIdList.includes(form.groupLargeId) && item.groupSmallIdList.includes(form.groupSmallId)) || isInoperableEntryStatus(item.serviceId)"
          :id="`serviceId-${item.serviceId}`"
          hide-details
          dense
          class="my-2 py-0"
        >
          <template v-slot:label>
              {{ item.serviceName[$i18n.locale] }}
              <span v-if="isDisplayableEntryStatus(item.serviceId)">&nbsp;【{{ $t("message.code.entryStatus." + getEntryStatus(item.serviceId)) }}】</span>
          </template>
        </v-checkbox>
        <p />
        <p>{{$t("message.account.change.desc.serviceText")}}</p>
      </v-col>
    </v-row>

    <!-- 申請ボタン -->
    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="clickChange">{{ $t('message.account.change.button.change') }}</mp-button>
        <mp-dialog modify :show="dialog.changeComplete" @clickOk="goTop" />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import i18n from '@/message'
import MpError from '@/components/item/MpError.vue'
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import constantValue from '@/constantValue'

import AccountApi from '@/api/account'
import Common from '@/api/common'

import StringUtils from '@/utils/StringUtil'

export default {
  name: 'AccountChange',
  components: {
    MpError,
    MpLabel,
    MpInputBox,
    MpButton,
    MpDialog
  },
  data: () => ({
    constantValue: constantValue,
    view: {
      errors: [],
      show: false,
      showConfirm: false,
      branchList: [],
      serviceList: [],
      companyLabel: {
        ja: '',
        en: ''
      },
      branchLabel: {
        ja: '',
        en: ''
      }
    },
    form: {
      mailAddress: '',
      password: '',
      passwordConfirm: '',
      name: '',
      groupLargeName: {
        ja: '',
        en: ''
      },
      companyInsNoFlg: '',
      groupSmallName: {
        ja: '',
        en: ''
      },
      companyLabel: {
        ja: '',
        en: ''
      },
      branchLabel: {
        ja: '',
        en: ''
      },
      companyId: null,
      companyName: '',
      branchId: null,
      branchName: '',
      branchNameKana: '',
      postNo: '',
      prefCd: '',
      addr1: '',
      addr2: '',
      addr3: '',
      busho: '',
      telNo: '',
      remarks: '',
      services: [],
      serviceApplications: [],
      locale: ''
    },
    dialog: {
      changeComplete: false
    },
    errMessageReplaceList: []
  }),
  computed: {
  },
  methods: {
    async loadViewData () {
      await AccountApi.getAccount()
        .then(result => { this.form = result })
        .catch(error => {
          this.view.errors = error.messages
        })

      this.view.serviceList = await Common.serviceList()

      if (this.form.companyId) {
        await Common.branchList({ companyId: this.form.companyId })
          .then(result => { this.view.branchList = result })
          .catch(error => {
            this.view.errors = error.messages
          })
      }
      // その他を追加
      this.view.branchList.push({
        branchName: i18n.t('message.account.change.select.other'),
        branchId: constantValue.otherBranchId
      })
    },
    initBranchList (otherOnlyFlg = false) {
      // 一覧および入力・選択情報を初期化
      if (!otherOnlyFlg) {
        this.view.branchList = []
        this.form.branchId = null
      }
      this.form.branchName = null
      this.form.branchNameKana = null
    },
    changeBranch (branchId) {
      // 支社・支局または媒体を初期化
      this.initBranchList(true)
    },
    getPrefName (item) {
      // 都道府県の選択肢の名前を多国語対応するためメソッドとして外だし
      return item.kbnVal[i18n.locale]
    },
    initServiceList () {
      this.form.services = []
    },
    goTop () {
      this.$router.push({ path: '/' })
    },
    async clickChange (ev) {
      this.form.locale = this.$i18n.locale
      await AccountApi.change(this.form)
        .then(() => {
        // 変更処理完了時にダイアログを表示
          this.dialog.changeComplete = true
        })
        .catch(error => { this.view.errors = error.messages })
    },
    async setCompanyAndBranchLabel () {
      const list = await Common.labelList({ key: 'default' })
      const companyDefaultLabel = {}
      const branchDefaultLabel = {}
      companyDefaultLabel.ja = this.getDefaultLabelFromList(list, 'label.default.company.ja')
      companyDefaultLabel.en = this.getDefaultLabelFromList(list, 'label.default.company.en')
      branchDefaultLabel.ja = this.getDefaultLabelFromList(list, 'label.default.branch.ja')
      branchDefaultLabel.en = this.getDefaultLabelFromList(list, 'label.default.branch.en')
      this.view.companyLabel.ja = StringUtils.isEmpty(this.form.companyLabel.ja) ? companyDefaultLabel.ja : this.form.companyLabel.ja
      this.view.companyLabel.en = StringUtils.isEmpty(this.form.companyLabel.en) ? companyDefaultLabel.en : this.form.companyLabel.en
      this.view.branchLabel.ja = StringUtils.isEmpty(this.form.branchLabel.ja) ? branchDefaultLabel.ja : this.form.branchLabel.ja
      this.view.branchLabel.en = StringUtils.isEmpty(this.form.branchLabel.en) ? branchDefaultLabel.en : this.form.branchLabel.en
    },
    getDefaultLabelFromList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      }
      return ele.configVal
    },
    setErrMessageReplaceList () {
      this.errMessageReplaceList = [
        { param: 'companyId', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel },
        { param: 'branchId', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel },
        { param: 'branchName', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel },
        { param: 'branchNameKana', pattern: '##BRANCH_LABEL##', replacement: this.view.branchLabel }
      ]
    },
    isInoperableEntryStatus (serviceId) {
      const serviceApp = this.getServiceApplication(serviceId)
      if (serviceApp) {
        return serviceApp.entryStatus === '1'
      } else {
        return false
      }
    },
    isDisplayableEntryStatus (serviceId) {
      const serviceApp = this.getServiceApplication(serviceId)
      if (serviceApp) {
        return serviceApp.entryStatus === '1' || serviceApp.entryStatus === '3'
      } else {
        return false
      }
    },
    getEntryStatus (serviceId) {
      const serviceApp = this.getServiceApplication(serviceId)
      if (serviceApp) {
        return serviceApp.entryStatus
      } else {
        return ''
      }
    },
    getServiceApplication (serviceId) {
      return this.form.serviceApplications.find((v) => {
        return serviceId === v.serviceId
      })
    }
  },
  created: async function () {
    this.view.constantValue = constantValue
    await this.loadViewData()
    await this.setCompanyAndBranchLabel()
    this.setErrMessageReplaceList()
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'IS_LANG_JA') {
        this.form.branchNameKana = ''
        // 'その他'の選択肢を言語で切り替え
        const branchList = this.view.branchList.map(item => item.branchId === constantValue.otherBranchId
          ? { branchName: i18n.t('message.account.change.select.other'), branchId: item.branchId }
          : item
        )
        this.view.branchList = branchList
      }
    })
  }
}
</script>

<style scoped>
/* deep selector で子コンポーネントの高さ制御 */
.v-messages {
  min-height: 0px !important;
}
.dummyPasswordFld {
  top: -100px; left: -100px; position: fixed;
}
</style>
